export default {
  partSpecification: 'Specyfikacja części',
  treatmentInformation: 'Informacje o leczeniu',
  partImages: 'Zdjęcia części',
  treatmentRemark: 'Uwaga dotycząca obróbki',
};
